/* Service type → Icon name mapping
   Used to decouple URL route params from icon identifiers */
const SERVICE_ICON_MAP = {
  airport: 'airport',
  golf: 'golf',
  ski: 'ski',
  hospital: 'hospital',
  pet: 'pet',
  business: 'business',
};

export default SERVICE_ICON_MAP;
